import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import AdminTextInput from '../../../components/admin/admin-text-input';
import AdminError from '../../../components/admin/admin-error';
import Loader from '../../../components/Loader'; 
import { showLoading, hideLoading } from '../../../store/loading-reducer';
import { updateSchool, getDistrictBySchoolId, getSchoolProductsBySchoolId, getSchoolProductOptionsBySchoolId } from '../../../api/schoolsApi';
import { schoolItems } from './schoolItems';
import SchoolUsers from '../districts/schoolUsers'
import SchoolProducts from '../districts/SchoolProducts';

export function AddEditSchool() {
    const { districtId, schoolId } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate(); 
    const [loading, setLoading] = useState(true);
    const [school, setSchool] = useState(schoolItems); 
    const [errorMessage, setErrorMessage] = useState('');
    const [validation, setValidation] = useState({ schoolName: true, schoolNameError: '' }); 
    const [schoolUsersList, setSchoolUsersList] = useState([]);
    const [schoolProducts, setSchoolProducts] = useState([]);
    const [schoolProductOptions, setSchoolProductOptions] = useState([]);    

    useEffect(() => {
        const loadSchoolData = async () => {
            setValidation({ schoolName: true, schoolNameError: '' });

            if (parseInt(schoolId, 10) === 0 || schoolId === undefined) {
                setSchool(schoolItems);
                setLoading(false);
                return;
            }

            try {
                const response = await getDistrictBySchoolId(districtId, schoolId);       
                if (response.data.success) {
                    setSchool(response.data.data);
                    setSchoolUsersList(response?.data?.data?.schoolUsers ?? []);
                    getProducts(schoolId);
                    getProductOptions(schoolId);
                } else {
                    setErrorMessage(response.data.message || 'Failed to load school.');
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setErrorMessage('An unknown error occurred.');
            } finally {
                setLoading(false);
            }
        };

        loadSchoolData();
    }, [districtId, schoolId]);


    const getProducts = async (schoolId) => {        
        try {
            const response = await getSchoolProductsBySchoolId(schoolId);      
            const { success, message, data } = response?.data || {};           
            if (success) {                      
                setSchoolProducts(data ?? [])
            } else {
                setErrorMessage(message || 'Failed to load school products.');
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setErrorMessage('An unknown error occurred while fetching school products.');
        }
    }

    const getProductOptions = async (schoolId) => {
        try {
            const response = await getSchoolProductOptionsBySchoolId(schoolId);
            const { success, message, data } = response?.data || {};
            if (success) {
                setSchoolProductOptions(data ?? [])
            } else {
                setErrorMessage(message || 'Failed to load school products.');
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setErrorMessage('An unknown error occurred while fetching school products.');
        }
    }


    const validateForm = () => {
        const trimmedName = school?.name?.trim();
        if (!trimmedName) {
            setValidation({
                schoolName: false,
                schoolNameError: 'School name is required'
            });
            return false;
        }
        return true;
    };

    const handleSchoolSave =  () => {
        if (!validateForm()) return;
        const updatedSchool = {
            ...school,
            schoolUsers: schoolUsersList,
            products: schoolProducts,
            productOptions: schoolProductOptions
        };
        try {
            dispatch(showLoading()); 
            updateSchool(districtId, updatedSchool)
                .then((response) => {
                    if (response.data.success) {
                        setLoading(false);  
                        navigate(`/admin/districts/edit/${districtId}/schools`); 
                    } else {
                        setLoading(false);
                        setErrorMessage(response.data.message || 'Failed to update school.');
                    }
                    dispatch(hideLoading());
                })
                .catch(() => {
                    dispatch(hideLoading());
                    setLoading(false);
                    setErrorMessage('An unknown error occurred getting user data.');
                });
        } catch (error) {
            dispatch(hideLoading());
            console.error('Save error:', error);
            setErrorMessage('An unexpected error occurred while saving.');
        } finally {   
            console.log("dispatch(hideLoading());");
        }
    };

    const handleCancel = () => {
        navigate(`/admin/districts/edit/${districtId}/schools`);
    };

    if (loading) return <Loader />;

    return (
        <div className="admin-page-wrap">
            <div className="admin-top-bar-wrap">
                <div className="admin-top-bar-left">
                    <Link className="admin-top-bar-back" to={`/admin/districts/edit/${districtId}/schools`}>
                        Back
                    </Link>
                </div>
            </div>

            <div className="admin-page-content">
                <h1 className="admin-page-heading">Add / Edit School</h1>

                <AdminError message={errorMessage} onClose={() => setErrorMessage('')} />

                <div className="admin-section">
                    <div className="admin-section-row">
                        <div className="admin-section-cell wide">
                            <AdminTextInput
                                id="school_name"
                                label="School Name"
                                value={school?.name ?? ''}
                                isRequired
                                onChange={(value) => setSchool({ ...school, name: value })}
                                validated={validation.schoolName}
                                requiredText={validation.schoolNameError}
                            />
                        </div>
                    </div>
                </div>

                <div className="admin-floating-button-wrap">
                    <button className="admin-floating-button" onClick={handleCancel}>
                        Cancel
                    </button>
                    <button className="admin-floating-button power" onClick={handleSchoolSave}>
                        Save Changes
                    </button>
                </div>
                {/* <DistrictUsers />*/} 
                {/* <SchoolUsers schoolUsersList={schoolUsersList} setSchoolUsersList={setSchoolUsersList} />*/}
                <SchoolUsers schoolUsersList={schoolUsersList} setSchoolUsersList={setSchoolUsersList} />
                <SchoolProducts
                    districtId={districtId}
                    schoolId={schoolId ? parseInt(schoolId) : 0}
                    schoolProducts={schoolProducts}
                    setSchoolProducts={setSchoolProducts}
                    schoolProductOptions={schoolProductOptions}
                    setSchoolProductOptions={setSchoolProductOptions}
                />

            </div>
            
        </div>
    );
}
